import { StoreApi, create } from 'zustand';

export type FullscreenLoaderStore = {
  isLoading: boolean;
  isInvisible: boolean;
  setIsLoading: ({ isLoading }: { isLoading: boolean }) => void;
  setIsInvisible: ({ isInvisible }: { isInvisible: boolean }) => void;
};

const useFullscreenLoaderStore = create<FullscreenLoaderStore>(
  (set: StoreApi<FullscreenLoaderStore>['setState']) => ({
    isLoading: false,
    isInvisible: false,
    setIsLoading: ({ isLoading }): void => set(() => ({ isLoading })),
    setIsInvisible: ({ isInvisible }): void =>
      set(() => ({ isInvisible: Boolean(isInvisible) })),
  }),
);

export default useFullscreenLoaderStore;
